import { IPayment, PaymentHdWallet, PaymentStatusState } from 'entities/payment/model/payment.types';
import { apiV2 } from 'shared';

import {
  CancelPaymentRequestData,
  CreatePaymentRequestData,
  EstimatedPaymentData,
  EstimatePaymentRequestData,
  NetworksTokensResponseData,
  VerifyPaymentRefCode,
} from './types';

export const fetchPaymentRequest = () => {
  return apiV2<PaymentStatusState>({
    url: '/payment_requests/',
    method: 'GET',
  });
};

export const getUserHdWallets = () => {
  return apiV2<PaymentHdWallet[]>({
    url: '/wallets/get_or_create/',
    method: 'GET',
  });
};

export const requestPayment = (data: CreatePaymentRequestData) => {
  return apiV2<IPayment>({
    url: '/payment_requests/',
    method: 'POST',
    data,
  });
};

export const cancelPaymentRequest = ({ requestId }: CancelPaymentRequestData) => {
  return apiV2<{ message: string }>({
    url: `/payment_requests/${requestId}/`,
    method: 'DELETE',
  });
};

export const estimatePayment = (data: EstimatePaymentRequestData) => {
  return apiV2<EstimatedPaymentData>({
    url: `/payment_requests/estimate/`,
    method: 'GET',
    params: {
      ...data,
    },
  });
};

export const verifyPaymentRefCode = (data: VerifyPaymentRefCode) => {
  return apiV2({
    url: `/payment_requests/verify-referral-code/`,
    method: 'GET',
    params: data,
  });
};

export const fetchPaymentNetworksTokens = () => {
  return apiV2<NetworksTokensResponseData[]>({
    url: `/networks/`,
    method: 'GET',
  });
};
